import React from "react";
import axios from 'axios';
import Products from "../Components/Products";
import './ProductList.css';
//import Slider from "react-slick";
import { useParams } from "react-router-dom";
import Listslider from "../Components/Listslider";
import Loader from "../Components/Loader";
class ProductList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],check:false,root:[]
        }
    }; 
    componentDidMount(){
        
        //alert("ok")
        this.setState({check:true})
        const  id2 = this.props.params['*'] ;
        //let {value}= this.props.params
        //console.log(id2)
        //this.setState({root:id2})
       
        
        
       
        //alert(id2)
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.item_list?item_group_route=products/'+id2 + '&pin=' + localStorage.getItem('pin')), {
            headers : { 
        'content-type': 'application/json'}
        })
                .then(response=>{
                    this.setState({list:response.data.message})
                    //console.log(response.data.message) 
                    this.setState({check:false}) 
                })
                .catch(response=>{
                    //console.log(response+'api/method/ecom.api.item_list?item_group_route='+this.props.route)
                })
       


    } 
    render() {
        var obj = [...this.state.list];
        obj.sort((a,b) => b.stock - a.stock);
//alert(this.props.params['*'])
         return this.state.check ? <Loader/> :
         (this.state.list.length ? <div> 
            
       <div className="shop-category-area">
                    <div className="container">
                        <Listslider minilist={this.props.params['*']}/>
                           
                        <div className="row">
                            <div className="col-md-12 product-height">

                                <div className="shop-bottom-area mt-35">
                                {/*   <!-- Shop Tab Content Start --> */}
                                    <div className="tab-content jump">
                                        {/*  <!-- Tab One Start --> */}
                                        <div id="shop-1" className="tab-pane active">
                                            <div className="row m-0">
                                            {obj.map((itm,k)=>{
                            return(
                                            <Products key={k} data={itm}/>)
                                        })} 
                                               
                                            </div>
                                        </div>
                                    {/*  <!-- Tab One End --> */}
                                        
                                    </div>
                                    {/* <!-- Shop Tab Content End -->
                                    <!--  Pagination Area Start --> */}
                                    
                                    {/*  <!--  Pagination Area End --> */}
                                </div>
                                {/* <!-- Shop Bottom Area End --> */}
                            </div>
                            
                        </div>
                    </div>
                </div>
               
            </div>:
            <div className="col-md-12 img-no-product">
               <img  className="" src="/assets/images/no-product-found.png" alt="img"/>
            </div>
            )
                /* <!-- Shop Category Area End --> */
              }
            }
           // export default ProductList;
           export default (props) => (
            <ProductList
                {...props}
                params={useParams()}
        />)
        